export const DEFAULT_CATEGORY_NAME = '전체';

export enum SEARCH_PARAMS {
  CATEGORY = 'category',
  BRAND = 'brand',
}

export enum SORT_TYPE {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
  PRICE_HIGH = 'PRICE_HIGH',
  PRICE_LOW = 'PRICE_LOW',
}

export const SORT_TYPE_OPTIONS = [
  { label: '최신순', value: SORT_TYPE.LATEST },
  { label: '인기순', value: SORT_TYPE.POPULAR },
  { label: '가격높은순', value: SORT_TYPE.PRICE_HIGH },
  { label: '가격낮은순', value: SORT_TYPE.PRICE_LOW },
];
